import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, from, map, of } from 'rxjs';
import { calcLegacyTheme } from '../../gallery/lib/calc-legacy-theme';
import { GalleryService } from '../../services/gallery.service';

export const publicGalleryPageThemeColorResolver: ResolveFn<string> = route => {
  const galleryService = inject(GalleryService);

  return from(galleryService.getPublicGalleryFromSnapshot(route)).pipe(
    map(gallery => {
      const theme = gallery.theme || calcLegacyTheme(gallery);
      return theme.layout_page.background_color;
    }),
    catchError(() => of(undefined as string))
  );
};
